import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { SERVICE_URL } from '../../../../tokens';

@Injectable({
  providedIn: 'root'
})
export class EmployerGroupService {

  private defaultTPAPartition = environment.defaultTPAPartition;

  constructor(private http: HttpClient, @Inject(SERVICE_URL) private serviceUrl: any) {
    this.serviceUrl = `${serviceUrl}`;
  }

  getEmployers(): Observable<any> {
    const params = new HttpParams({
      fromObject: {
          'tpaPartition' : this.defaultTPAPartition
      }
    });

    return this.http.get(this.serviceUrl + 'Employers', {params: params});
  }

}
